module.exports = __webpack_public_path__ + "img/thumb_40.b2587c3d.jpg";